/*
 * @Author: suxueqin
 * @Date: 2021-01-06
 * @Last Modified by: yanghuizi
 * @Last Modified time: 2022-06-28 10:24:10
 *
 * 封装一个公用的请求
 */
import axios from 'axios';
import { IS_TEST } from "../consts"; 
//开启跨域
axios.defaults.withCredentials = true;

/**
 * 发出ajx请求
 * @param {object} options 参见 `wx.request` 接收的参数
 * @param {object} config 请求配置
 * config:
 * @param {boolean} withEnv: 为 true 表示带上公共参数
 * 
 * 
 */

 /** Make request and return a promise */
const request = (options)=>{
  let promise = new Promise((resolve, reject) => {
    axios(Object.assign({}, options)).then(res=>{
        resolve(res)
    }).catch(res=>{
        reject(res)
    });
  });
  return promise;
}


const httpFetch = (options, config)=>{
  let { withEnv = false } = config || {};
  let { data = {}, method, url } = options || {};

  if (withEnv) {
    // 获取公参
    data = Object.assign(getEnvVariables(), data);
  }

  // if (method && method.toLowerCase() === "post") {
  //   // 如果是post请求
  //   let qs = qstringify(data);
  //   options.url = url.indexOf("?") > -1 ? url + "&" + qs : url + "?" + qs;
  // }
  //let { _mockId } = options;
  // let fn = IS_DEV && _mockId ? mockRequest : request;
  let fn = request;
  return fn(Object.assign({}, options, { data }));
}


/**
 * 参数参见 httpFetch
 */
const fetchData = (options, config)=>{
  if (!options) options = {};

  let { method = "POST", headers = { } } = options;

  headers["X-Requested-With"] = "XMLHttpRequest"; // 防止部分请求会返回html
 
  // 如果是本地测试环境 传了token api接口就不验证登录
  if(IS_TEST) {
    headers["Authorization"] = "c3NpZD0xNDMzMWE2MDQ1NzI3N2I1MDRiZjNhYWY2N2Q0NGNmZjI4OTU4NTE5O3VpZD00MDk1O2dpZD0w"
  }

  if (method.toUpperCase() === "POST") {
    let contentType =
    headers["content-type"] ||
    headers["Content-Type"] ||
    headers["content-Type"] ||
    headers["Content-type"] ||
    "application/json";
    headers = Object.assign({}, headers, { "Content-Type": contentType });
  }

  options.method = method;
  options.headers = headers;

  return httpFetch(options, config).then((res) => {
    let { data, msg, code } = res.data;
    if (code == 200 || code == 1) {
      return { data }
    } else {
      return Promise.reject({ code, errMsg: msg, data, response: res });
    }
  });
}

export default { fetchData };


// WEBPACK FOOTER //
// ./src/utils/fetch.js